export default {
  control: {
    backgroundColor: '#fff',
    fontSize: 13.7,
    fontWeight: 'normal',
  },

  '&singleLine': {
    display: 'inline-block',
    width: '100%',
    color: '#000',
    
    highlighter: {
      color: '#7E0386',
    },
    input: {
      padding: 1,
      border: 'none',
      width: '100%',
    },
  },

  suggestions: {
    width: '100%',
    top: 10,
    zIndex: 1400,
    overflowY: 'scroll',
    
    list: {
      backgroundColor: '#fff',
      border: '1px solid rgba(0,0,0,0.15)',
      fontSize: 14,
    },
    item: {
      padding: '15px 15px',
      borderBottom: '1px solid rgba(0,0,0,0.15)',

      '&focused': {
        backgroundColor: '#cee4e5',
      },
    },
  },
};